import moment from 'moment'
import zodiaks from '../assets/zodiaks'

export default {
    data() {
        return {
            zodiaks,
            messages: [
                {
                    text: 'Hello. Many people don’t believe in predictions by the stars. This is why I want to prove that an astrological forecast can change anyone’s life – and even yours!',
                    type: 'text'
                },
                {
                    text: 'I am a professional astrology consultant, a teacher of classical astrology. For over 19 years I’ve been helping people to solve their personal issues: broken families reunited, single women found their other halves, unemployed people started earning good money, business owners found ways to improve their businesses.',
                    type: 'text'
                },
                {
                    text: 'In just 3 minutes, you will learn a lot of interesting facts about your future! Tell me, what do you want to learn about most of all? ',
                    answers: [
                        {
                            id: 1,
                            answer: 'Health',
                            active: false
                        },{
                            id: 2,
                            answer: 'Money',
                            active: false
                        },{
                            id: 3,
                            answer: 'Family and Relationships',
                            active: false
                        },{
                            id: 4,
                            answer: 'Everything',
                            active: false
                        }
                    ],
                    type: 'question'
                },
                {
                    text: 'Alright, thank you. I will only ask 3 more questions. What time of the day do you feel your best?',
                    answers: [
                        {
                            id: 5,
                            answer: 'Morning',
                            active: false
                        },{
                            id: 6,
                            answer: 'Night',
                            active: false
                        },{
                            id: 7,
                            answer: 'Evening',
                            active: false
                        },{
                            id: 8,
                            answer: 'Day',
                            active: false
                        }
                    ],
                    type: 'question'
                },
                {
                    text: 'I see. Tell me, have you been suffering from insomnia lately?',
                    answers: [
                        {
                            id: 9,
                            answer: 'Yes',
                            active: false
                        },{
                            id: 10,
                            answer: 'No',
                            active: false
                        },{
                            id: 11,
                            answer: 'Sometimes',
                            active: false
                        }
                    ],
                    type: 'question'
                },
                {
                    text: 'And the last question, have you been feeling lately that you keep failing to make your dreams come true? ',
                    answers: [
                        {
                            id: 12,
                            answer: 'Yes',
                            active: false
                        },{
                            id: 13,
                            answer: 'No',
                            active: false
                        },{
                            id: 14,
                            answer: 'Sometimes',
                            active: false
                        }
                    ],
                    type: 'question'
                },
                {
                    text: 'Thank you for answering all my questions.',
                    type: 'text'
                },
                {
                    text: 'But there’s one more important thing that I need to know.',
                    type: 'text'
                },
                {
                    text: 'Please, enter your date of birth:',
                    type: 'date',
                    stop: true
                },
                {
                    text: `I see. Your life path number is <span style="font-weight: normal;color: #4166B1;">${this.socralNumber(4, 10)}</span>, and I want to warn you that it signifies worry.`,
                    type: 'text'
                },
                {
                    text: 'I know that you often doubt your decisions and worry whether you made the right choice or not in a particular situation.',
                    type: 'text'
                },
                {
                    text: `Shortly, you will receive a piece of news that you didn’t expect. Perhaps, on <span style="font-weight: normal;color: #4166B1;">${this.changesDate()}</span>. Your regular life will be turned upside down.`,
                    city: true
                },
                {
                    text: 'I’m going to record a voice message for you now. You can listen to it by calling me from your mobile phone.',
                    type: 'text'
                },
                {
                    text: 'You will see a button "Call now" down below, press it and dial my number. Listen to the recording – it’s very important for you!',
                    type: 'text'
                }
            ],
            zodiak: null
        }
    },
    methods: {
        socralNumber(min, max) {
            return Math.floor(Math.random() * (max - min + 1) + min);
        },
        changesDate() {
            moment.locale('en');
            var currentDay = moment().format('DD MMMM');
            var nextDay = moment().add(1, 'day').format('DD MMMM');
            return `${currentDay}-${nextDay}`
        },
        dynamicText(text, index) {
            var city = `Shortly, you will receive a piece of news that you didn’t expect. Perhaps, on <span style="font-weight: normal;color: #4166B1;">${this.changesDate()}</span>. Your regular life will be turned upside down.`;
            var textToSend;
            switch (text) {
                case 'city':
                    textToSend = city;
                    break;
                default:
                    textToSend = text;
                    break;
            }
            this.messages.splice(this.midx + index, 1, {text: textToSend});
        },
        getZodiak() {
            var zodiak;
            switch (this.pickedMonth) {
                case 1:
                    if (this.pickedDay < 20) {
                        zodiak = 10;
                    } else {
                        zodiak = 11;
                    }
                    break;
                case 2:
                    if (this.pickedDay < 19) {
                        zodiak = 11;
                    } else {
                        zodiak = 12;
                    }
                    break;
                case 3:
                    if (this.pickedDay < 21) {
                        zodiak = 12;
                    } else {
                        zodiak = 1;
                    }
                    break;
                case 4:
                    if (this.pickedDay < 20) {
                        zodiak = 1;
                    } else {
                        zodiak = 2;
                    }
                    break;
                case 5:
                    if (this.pickedDay < 21) {
                        zodiak = 2;
                    } else {
                        zodiak = 3;
                    }
                    break;
                case 6:
                    if (this.pickedDay < 21) {
                        zodiak = 3;
                    } else {
                        zodiak = 4;
                    }
                    break;
                case 7:
                    if (this.pickedDay < 23) {
                        zodiak = 4;
                    } else {
                        zodiak = 5;
                    }
                    break;
                case 8:
                    if (this.pickedDay < 23) {
                        zodiak = 5;
                    } else {
                        zodiak = 6;
                    }
                    break;
                case 9:
                    if (this.pickedDay < 23) {
                        zodiak = 6;
                    } else {
                        zodiak = 7;
                    }
                    break;
                case 10:
                    if (this.pickedDay < 23) {
                        zodiak = 7;
                    } else {
                        zodiak = 8;
                    }
                    break;
                case 11:
                    if (this.pickedDay < 22) {
                        zodiak = 8;
                    } else {
                        zodiak = 9;
                    }
                    break;
                case 12:
                    if (this.pickedDay < 22) {
                        zodiak = 9;
                    } else {
                        zodiak = 10;
                    }
                    break;
            }
            return this.zodiaks[zodiak - 1];
        }
    }
}